<template>
  <section class="flex flex-col gap-8">
    <h2
      class="w-full font-national2condensed text-[40px] font-medium leading-[44px] text-[--theme-dark] md:text-6xl md:leading-[80px]"
    >
      En studieplattform som hjelper studenter å forstå pensum
    </h2>
    <p
      class="font-national2 text-xl font-normal leading-[30px] md:text-3xl md:leading-10"
    >
      Pensum kan være krevende. Kunne er laget for deg som vil ha en
      <b>enklere</b> og mer levende måte å <b>forstå pensum</b> på.
    </p>
    <p
      class="font-national2 text-xl font-normal leading-[30px] md:text-3xl md:leading-10"
    >
      Vi lager Kunne slik at du kan lære mer <b>effektivt</b> og
      <b>engasjerende</b>. Med Kunne får du pensum gjennom video,
      korte tekster, quizer, og lydavspilling av tekst. Kunne skal
      lære deg det som er <b>relevant</b> til eksamen.
    </p>
    <p
      class="font-national2 text-xl font-normal leading-[30px] md:text-3xl md:leading-10"
    >
      Vi har kurs for studenter på <b>UiO</b>, <b>NTNU</b>,
      <b>UiA</b>, <b>BI</b>, <b>NHH</b> og <b>Kristiania</b>. Kunne er
      laget av forfattere sammen med redaktører i
      Universitetsforlaget, Aschehougs akademiske forlag.
    </p>
  </section>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
